(function(){
  var root = document.querySelector('.ekh-wrap');
  if(!root || root.dataset.ekhInit) return;
  root.dataset.ekhInit = "1";

  var cfg = {};
  try{ cfg = JSON.parse(document.getElementById('ekh-config').textContent); }catch(e){}

  var ICON = {
    city:'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21h18M5 21V7l7-4 7 4v14M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01"/></svg>',
    route:'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="19" r="3"/><circle cx="18" cy="5" r="3"/><path d="M9 19h6a3 3 0 0 0 3-3V8"/></svg>',
    cargo:'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="13" height="10" rx="1"/><path d="M15 10h4l3 3v4h-7"/><circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>',
    mountain:'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m8 3 4 8 5-5 5 14H2L8 3z"/></svg>',
    compact:'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M9 9h6v6H9z"/></svg>',
    comfort:'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8 12h8M12 8v8"/></svg>',
    bike:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="5.5" cy="17.5" r="3.5"/><circle cx="18.5" cy="17.5" r="3.5"/><path d="M15 17.5 12 6h3M9 6h3l3 6-7 .5"/></svg>',
    tag:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3H4a1 1 0 0 0-1 1v5.59A2 2 0 0 0 3.83 11l9.58 9.59a2 2 0 0 0 2.83 0l4.35-4.35a2 2 0 0 0 0-2.83z"/><circle cx="7" cy="7" r="1"/></svg>',
    euro:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3a8 8 0 1 0 0 18M5 9h6M5 14h5"/></svg>',
    star:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15 9 22 9.5 17 14.5 18.5 22 12 18 5.5 22 7 14.5 2 9.5 9 9 12 2"/></svg>'
  };

  var C = {
    stad:{h:"stadsfietsen",l:"Stadsfietsen"},
    nwStad:{h:"nieuwe-stadsfietsen",l:"Nieuwe stadsfietsen"},
    thStad:{h:"tweedehands-stadsfietsen",l:"Tweedehands stadsfietsen"},
    compact:{h:"compact-fietsen",l:"Compacte & vouwbare e-bikes"},
    sportief:{h:"sportieve-fietsen",l:"Sportieve e-bikes"},
    duur:{h:"fietsen-vanaf-3000",l:"Premium e-bikes vanaf €3.000"},
    baklong:{h:"bakfietsen-longtails",l:"Bakfietsen & longtails"},
    bak:{h:"bakfietsen",l:"Bakfietsen"},
    long:{h:"longtails",l:"Longtails"},
    emtb:{h:"elektrische-mountainbikes",l:"Elektrische mountainbikes"},
    fat:{h:"fatbikes",l:"Fatbikes"},
    drie:{h:"driewielers",l:"Driewielers"},
    dames:{h:"damesfietsen",l:"Dames- & lage-instap e-bikes"},
    nieuw:{h:"nieuwe-elektrische-fietsen",l:"Nieuwe e-bikes"},
    demo:{h:"demo",l:"Demo e-bikes"},
    goedkoop:{h:"fietsen-onder-de-1600-euro",l:"E-bikes onder €1.600"},
    tweedehands:{h:"tweedehands-en-demo-e-bikes",l:"Tweedehands & demo e-bikes"},
    deals:{h:"ebikexl-deals-met-extra-hoge-kortingen",l:"Deals met extra hoge korting"},
    lang:{h:"lange-afstand-e-bikes",l:"Lange-afstand e-bikes"}
  };
  function url(handle){ return "/collections/" + handle; }

  var QUESTIONS = [
    { id:"gebruik", cols:"cols2",
      title:"Waar ga je je e-bike vooral voor gebruiken?",
      sub:"Dit bepaalt het type fiets dat het beste bij je past.",
      options:[
        {v:"stad",     l:"Stad & dagelijks",     d:"Woon-werk, boodschappen, korte ritten", ic:"city"},
        {v:"toeren",   l:"Toeren & sportief",    d:"Lange ritten, recreatie, fietsvakanties", ic:"route"},
        {v:"lading",   l:"Kinderen & lading",    d:"Gezin, boodschappen en spullen vervoeren", ic:"cargo"},
        {v:"avontuur", l:"Avontuur & offroad",   d:"Bos, mountainbiken, ruig terrein", ic:"mountain"},
        {v:"compact",  l:"Compact & flexibel",   d:"Klein, opvouwbaar, mee in auto, boot of OV", ic:"compact"},
        {v:"comfort",  l:"Comfort & stabiliteit",d:"Extra stabiel, makkelijk op- en afstappen", ic:"comfort"}
      ]},
    { id:"afstand", cols:"cols2",
      title:"Hoeveel kilometer rijd je gemiddeld per rit?",
      sub:"Zo bepalen we de ideale accucapaciteit en motorondersteuning.",
      options:[
        {v:"kort",  l:"Tot 10 km"},
        {v:"middel",l:"10 – 30 km"},
        {v:"lang",  l:"30 – 50 km"},
        {v:"extra", l:"Meer dan 50 km"}
      ]},
    { id:"conditie", cols:"cols2",
      title:"Nieuw, demo of tweedehands?",
      sub:"Je vindt alle drie bij eBikeXL — elk met volledige garantie.",
      options:[
        {v:"nieuw",      l:"Nieuw",            d:"De allernieuwste modellen"},
        {v:"demo",       l:"Demo / showroom",  d:"Nauwelijks gereden, scherp geprijsd"},
        {v:"tweedehands",l:"Tweedehands",      d:"Het meeste voordeel, gekeurd & rijklaar"},
        {v:"deal",       l:"Beste deal",       d:"Toon mij de scherpste aanbiedingen"}
      ]},
    { id:"budget", cols:"cols2",
      title:"Wat is je budget ongeveer?",
      sub:"We tonen je opties die hierbij passen.",
      options:[
        {v:"laag",  l:"Tot € 1.600"},
        {v:"midden",l:"€ 1.600 – € 3.000"},
        {v:"hoog",  l:"€ 3.000 of meer"},
        {v:"open",  l:"Beste prijs-kwaliteit"}
      ]},
    { id:"frame", cols:"cols3",
      title:"Voor wie is de e-bike?",
      sub:"Bepaalt onder andere het frametype en de instaphoogte.",
      options:[
        {v:"dames",l:"Dames / lage instap", d:"Comfortabel makkelijk opstappen"},
        {v:"heren",l:"Heren"},
        {v:"geen", l:"Maakt niet uit"}
      ]}
  ];

  var SCORE = {
    gebruik: {
      stad:     {stad:6},
      toeren:   {sportief:3, stad:2},
      lading:   {baklong:6},
      avontuur: {emtb:4, fat:3},
      compact:  {compact:6, stad:1},
      comfort:  {stad:5, dames:3, drie:2}
    },
    afstand: {
      kort:   {stad:3},
      middel: {stad:3},
      lang:   {sportief:3, stad:1},
      extra:  {sportief:4, stad:1}
    },
    frame: {
      dames: {dames:3, stad:1},
      heren: {stad:1},
      geen:  {}
    }
  };
  var ORDER = ["baklong","emtb","fat","compact","sportief","dames","drie","stad"];

  var TYPE_INFO = {
    stad:    {coll:"stad", title:"Een comfortabele stadsfiets", desc:"De ideale keuze voor dagelijks gebruik in en om de stad: woon-werkverkeer, boodschappen en korte ritten. Verkrijgbaar als nieuwe én als voordelige tweedehands e-bike.", secondary:["nwStad","thStad"]},
    compact: {coll:"compact", title:"Een compacte of vouwbare e-bike", desc:"Klein, wendbaar en makkelijk mee te nemen in de auto, boot, camper of het OV.", secondary:["stad","nieuw"]},
    sportief: {coll:"sportief", title:"Een sportieve e-bike", desc:"Gemaakt voor langere afstanden, recreatieve tochten en fietsvakanties met veel rijplezier.", secondary:["stad","lang"]},
    baklong:  {coll:"baklong", title:"Een bakfiets of longtail", desc:"De ruimste oplossing om kinderen, boodschappen en lading veilig en comfortabel te vervoeren.", secondary:["bak","long"]},
    emtb:     {coll:"emtb", title:"Een elektrische mountainbike", desc:"Krachtige ondersteuning en grip voor bospaden, heuvels en ruig terrein.", secondary:["fat","sportief"]},
    fat:      {coll:"fat", title:"Een fatbike", desc:"Brede banden voor extra grip en een stoere uitstraling op elk terrein.", secondary:["emtb","sportief"]},
    dames:    {coll:"dames", title:"Een comfortabele dames- of lage-instapfiets", desc:"Lage instap en stabiel rijgedrag, zodat op- en afstappen altijd makkelijk gaat.", secondary:["stad","nieuw"]},
    drie:     {coll:"drie", title:"Een extra stabiele driewieler", desc:"Maximale stabiliteit en comfort, perfect wanneer balans en gemak vooropstaan.", secondary:["dames","stad"]}
  };

  var state = { step:0, answers:{}, type:null, leadDone:false };

  var quizEl   = document.getElementById('ekh-quiz');
  var resultEl = document.getElementById('ekh-result');
  var leadEl   = document.getElementById('ekh-lead');
  var leadForm = document.getElementById('ekh-lead-form');
  var leadSkip = document.getElementById('ekh-lead-skip');
  var optsEl   = document.getElementById('ekh-opts');
  var titleEl  = document.getElementById('ekh-qtitle');
  var subEl    = document.getElementById('ekh-qsub');
  var stepLbl  = document.getElementById('ekh-steplabel');
  var barFill  = document.getElementById('ekh-barfill');
  var backBtn  = document.getElementById('ekh-back');
  var skipBtn  = document.getElementById('ekh-skip');

  function track(ev, data){
    try{
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({event: ev}, data||{}));
    }catch(e){}
  }

  function render(){
    var q = QUESTIONS[state.step];
    titleEl.textContent = q.title;
    subEl.textContent = q.sub;
    stepLbl.textContent = "Vraag " + (state.step+1) + " van " + QUESTIONS.length;
    barFill.style.width = ((state.step) / QUESTIONS.length * 100) + "%";
    backBtn.classList.toggle('ekh-hidden', state.step === 0);
    skipBtn.classList.toggle('ekh-hidden', !q.optional);

    optsEl.className = "ekh-opts " + (q.cols || "");
    optsEl.innerHTML = "";
    q.options.forEach(function(o){
      var b = document.createElement('button');
      b.type = "button";
      b.className = "ekh-opt";
      var ic = o.ic ? '<span class="ic">'+(ICON[o.ic]||ICON.bike)+'</span>' : '';
      var dd = o.d ? '<small>'+o.d+'</small>' : '';
      b.innerHTML = ic + '<span class="tx"><b>'+o.l+'</b>'+dd+'</span>'+
        '<span class="arr"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></span>';
      b.addEventListener('click', function(){ choose(q.id, o.v); });
      optsEl.appendChild(b);
    });
    quizEl.scrollIntoView({behavior:'smooth', block:'nearest'});
  }

  function choose(qid, val){
    state.answers[qid] = val;
    track('keuzehulp_antwoord', {stap: state.step+1, vraag: qid, antwoord: val});
    next();
  }

  function next(){
    if(state.step < QUESTIONS.length - 1){
      state.step++;
      render();
    } else {
      enterLead();
    }
  }

  skipBtn.addEventListener('click', function(){
    var q = QUESTIONS[state.step];
    state.answers[q.id] = "geen";
    track('keuzehulp_overgeslagen', {stap: state.step+1, vraag:q.id});
    next();
  });

  backBtn.addEventListener('click', function(){
    if(state.step > 0){ state.step--; render(); }
  });

  function computeType(){
    var a = state.answers;
    var totals = {};
    function add(map){ if(!map) return; for(var k in map){ totals[k] = (totals[k]||0) + map[k]; } }
    add(SCORE.gebruik[a.gebruik]);
    add(SCORE.afstand[a.afstand]);
    add(SCORE.frame[a.frame]);
    var best = null, bestScore = -1;
    for(var i=0;i<ORDER.length;i++){
      var t = ORDER[i], s = totals[t] || 0;
      if(s > bestScore){ bestScore = s; best = t; }
    }
    if(!best || bestScore <= 0){ best = "stad"; }
    return best;
  }

  function enterLead(){
    state.type = computeType();
    track('keuzehulp_lead_getoond', {advies: state.type});
    quizEl.classList.add('ekh-hidden');
    resultEl.classList.add('ekh-hidden');
    leadEl.classList.remove('ekh-hidden');
    barFill.style.width = "100%";
    leadEl.scrollIntoView({behavior:'smooth', block:'start'});
  }

  if(leadForm){
    leadForm.addEventListener('submit', function(e){
      e.preventDefault();
      var a = state.answers;
      var tags = ['keuzehulp-lead'];
      if(a.gebruik) tags.push('gebruik-'+a.gebruik);
      if(a.conditie) tags.push('conditie-'+a.conditie);
      if(a.budget) tags.push('budget-'+a.budget);
      if(state.type) tags.push('advies-'+state.type);
      var tagsEl = document.getElementById('ekh-lead-tags');
      if(tagsEl){ tagsEl.value = tags.join(', '); }
      state.leadDone = true;
      track('keuzehulp_lead_ingevuld', {advies: state.type});
      try{
        var fd = new FormData(leadForm);
        fetch(leadForm.action, {method:'POST', body:fd, headers:{'Accept':'application/json'}}).catch(function(){});
      }catch(err){}
      showResult();
    });
  }
  if(leadSkip){
    leadSkip.addEventListener('click', function(){
      track('keuzehulp_lead_overgeslagen', {advies: state.type});
      showResult();
    });
  }

  function secCard(c){
    return '<a class="ekh-sec-card" href="'+url(c.h)+'" data-ekh-cta="secondary"><span class="ic">'+ICON.bike+'</span>'+
      '<span><b>'+c.l+'</b><small>Bekijk de collectie</small></span></a>';
  }
  function chip(label, c, icon){
    return '<a class="ekh-chip" href="'+url(c.h)+'" data-ekh-cta="refine">'+(ICON[icon]||ICON.tag)+label+'</a>';
  }

  function showResult(){
    var a = state.answers;
    var type = state.type || computeType();
    var info = TYPE_INFO[type] || TYPE_INFO.stad;
    var primary = C[info.coll];
    var primTitle = info.title;
    var primHandle = primary.h;

    if(type === "stad"){
      if(a.conditie === "nieuw"){ primTitle = "Een nieuwe stadsfiets"; primHandle = C.nwStad.h; }
      else if(a.conditie === "tweedehands"){ primTitle = "Een tweedehands stadsfiets"; primHandle = C.thStad.h; }
      else if(a.conditie === "demo"){ primTitle = "Een demo stadsfiets"; primHandle = C.demo.h; }
      else if(a.conditie === "deal"){ primTitle = "Een stadsfiets met topkorting"; primHandle = C.deals.h; }
    }

    document.getElementById('ekh-res-title').textContent = "Dit raden wij jou aan";
    document.getElementById('ekh-res-text').textContent =
      "Op basis van jouw antwoorden past dit het beste bij je. Verfijn hieronder verder op budget, conditie of merk — of vraag ons om persoonlijk advies.";

    document.getElementById('ekh-prim-title').textContent = primTitle;
    document.getElementById('ekh-prim-desc').textContent = info.desc;
    document.getElementById('ekh-prim-link').href = url(primHandle);

    var chips = [];
    if(a.conditie === "nieuw") chips.push(chip("Nieuwe modellen", C.nieuw, "tag"));
    else if(a.conditie === "demo") chips.push(chip("Demo e-bikes", C.demo, "tag"));
    else if(a.conditie === "tweedehands") chips.push(chip("Tweedehands & demo", C.tweedehands, "tag"));
    else if(a.conditie === "deal") chips.push(chip("Scherpste deals", C.deals, "tag"));

    if(a.budget === "laag") chips.push(chip("Tot € 1.600", C.goedkoop, "euro"));
    else if(a.budget === "hoog") chips.push(chip("Vanaf € 3.000", C.duur, "euro"));
    else if(a.budget === "open") chips.push(chip("Beste prijs-kwaliteit", C.demo, "euro"));

    if(a.afstand === "extra" || a.afstand === "lang") chips.push(chip("Lange afstand (grote accu)", C.lang, "tag"));

    if(a.frame === "dames" && type !== "dames") chips.push(chip("Dames & lage instap", C.dames, "bike"));

    var refineWrap = document.getElementById('ekh-refine-wrap');
    if(chips.length){
      document.getElementById('ekh-chips').innerHTML = chips.join("");
      refineWrap.classList.remove('ekh-hidden');
    } else {
      refineWrap.classList.add('ekh-hidden');
    }

    var secHtml = info.secondary.map(function(k){ return secCard(C[k]); }).join("");
    document.getElementById('ekh-sec').innerHTML = secHtml;

    var callBtn = resultEl.querySelector('[data-ekh-cta="call"]');
    if(callBtn && cfg.telShop){ callBtn.href = "tel:"+cfg.telShop; callBtn.textContent = "Bel "+cfg.telShop; }

    var note = document.getElementById('ekh-lead-note');
    if(note){ note.classList.toggle('ekh-hidden', !state.leadDone); }

    leadEl.classList.add('ekh-hidden');
    quizEl.classList.add('ekh-hidden');
    resultEl.classList.remove('ekh-hidden');
    barFill.style.width = "100%";
    track('keuzehulp_resultaat', {gebruik:a.gebruik, afstand:a.afstand, conditie:a.conditie, budget:a.budget, frame:a.frame, advies_type:type, primaire_collectie:primHandle});
    resultEl.scrollIntoView({behavior:'smooth', block:'start'});
  }

  document.getElementById('ekh-restart').addEventListener('click', function(){
    state = {step:0, answers:{}, type:null, leadDone:false};
    resultEl.classList.add('ekh-hidden');
    leadEl.classList.add('ekh-hidden');
    quizEl.classList.remove('ekh-hidden');
    render();
    track('keuzehulp_opnieuw', {});
  });

  root.addEventListener('click', function(e){
    var aEl = e.target.closest('[data-ekh-cta]');
    if(aEl){ track('keuzehulp_cta_klik', {type: aEl.getAttribute('data-ekh-cta'), bestemming: aEl.getAttribute('href')}); }
  });

  track('keuzehulp_gestart', {});
  render();
})();
